import { useContext } from 'react';
import * as React from 'react';
import { PostPurchaseContext } from '@/features/editor/widgets/post-purchase/context';
import {
  DropdownInput,
  DropdownInputOption,
} from '@/features/editor/widgets/custom-widget/inputs/shared/dropdown';
import { InputsDarkTheme } from '@/features/editor/widgets/custom-widget/inputs/shared/input-type';

export function PostPurchaseTaxIncluded() {
  const {
    props: {
      settings: { addTaxToFinalPrice },
    },
    setProps,
  } = useContext(PostPurchaseContext);

  const options: DropdownInputOption[] = [
    { label: `Don't show taxes on the discounted price`, value: false },
    { label: `Show taxes on the discounted price`, value: true },
  ];

  const onChange = (val: DropdownInputOption) => {
    setProps((draft) => {
      draft.settings.addTaxToFinalPrice = val.value as boolean;
    });
  };

  return (
    <DropdownInput
      theme={InputsDarkTheme}
      options={options}
      defaultValue={addTaxToFinalPrice ? options[1] : options[0]}
      onChange={onChange}
      optionStyles={{ textTransform: `uppercase` }}
    />
  );
}
